import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingEventUpsert, ITrainingEvent, IGetPutRequest } from '../../interfaces'

const getUpdateTrainingEventMutationRequest: IGetPutRequest = params => {
  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingEvents`,
  }
}

const useUpdateTrainingEventMutation: IUseUpdateMutation<ITrainingEvent, ITrainingEventUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingEventMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingEventUpsert, ITrainingEvent> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingEvent, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingEventMutation
